import { render, staticRenderFns } from "./freedeliveryList.vue?vue&type=template&id=55162a10&scoped=true&"
import script from "./freedeliveryList.vue?vue&type=script&lang=js&"
export * from "./freedeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./freedeliveryList.vue?vue&type=style&index=0&id=55162a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55162a10",
  null
  
)

export default component.exports